import { useState, useEffect } from 'react';
import { useEscortsData } from './useEscortsData';

export const useCategories = () => {
  const [categories, setCategories] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const { escorts } = useEscortsData();

  useEffect(() => {
    if (escorts.length > 0) {
      // Estrai categorie uniche dagli escort
      const uniqueCategories = escorts
        .map(escort => escort.category)
        .filter(category => category && category.trim() !== '')
        .filter((category, index, array) => array.indexOf(category) === index)
        .sort();

      // Se non ci sono categorie dall'API, usa quelle predefinite
      const finalCategories = uniqueCategories.length > 0 ? uniqueCategories : [
        'Escort Premium',
        'Escort VIP',
        'Escort di Lusso',
        'Escort Business',
        'Escort per Eventi',
        'Escort Travel',
        'Escort Mature',
        'Escort Giovani'
      ];

      setCategories(finalCategories);
      setLoading(false);
    }
  }, [escorts]);

  return {
    categories,
    loading
  };
};

export default useCategories;
